import React, { useContext } from 'react';
import { I18nContext } from 'translations';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  IconButton,
  Divider,
} from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloseIcon from '@material-ui/icons/Close';
import { useStateValue } from 'context/store';
import { resetTermsForCompanyChange } from 'context/settings/companyRegister/actions';

const DocumentRow = ({ label, href }) => {
  const { translate } = useContext(I18nContext);
  return (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #E5E7EB',
      borderRadius: '10px',
      padding: '14px 16px',
      marginBottom: '10px',
    }}
  >
    <div
      style={{
        backgroundColor: '#EEF2FF',
        borderRadius: '8px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '14px',
        flexShrink: 0,
      }}
    >
      <AssignmentIcon style={{ color: '#4F46E5', fontSize: 22 }} />
    </div>
    <Typography variant="body1" style={{ flexGrow: 1, color: '#111' }}>
      {label}
    </Typography>
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#4F46E5',
        fontWeight: 500,
        fontSize: '15px',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        marginLeft: '12px',
      }}
    >
      {translate('app.operations.optimize.table.file.see')} →
    </a>
  </div>
  );
};

const ModalTermsDetails = ({ open, companyId, hasComment, onAccept, onLimitante, onClose }) => {
  const { translate } = useContext(I18nContext);
  const [, dispatch] = useStateValue();
  const documents = [
    { label: translate('company.change.details.doc.commerceChamber'), href: '/company/camara_de_comercio_network.pdf' },
    { label: translate('company.change.details.doc.rut'), href: '/company/rut.pdf' },
    { label: translate('company.change.details.doc.bankCert'), href: 'company/certificacion_bancaria.pdf' },
  ];

  const handleAccept = async () => {
    await resetTermsForCompanyChange(dispatch, companyId);
    onAccept && onAccept();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { borderRadius: '16px', padding: '8px' } }}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 8px 0' }}>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      <DialogContent style={{ padding: '0 28px 28px' }}>
        <div
          style={{
            display: 'inline-block',
            backgroundColor: '#EEF2FF',
            color: '#4F46E5',
            borderRadius: '20px',
            padding: '4px 14px',
            fontSize: '13px',
            fontWeight: 500,
            marginBottom: '16px',
          }}
        >
          {translate('company.change.details.badge')}
        </div>

        <Typography
          variant="h5"
          style={{ fontWeight: 700, marginBottom: '16px', lineHeight: 1.3, color: '#111' }}
        >
          {translate('company.change.details.title')}
        </Typography>

        <Typography variant="body1" style={{ marginBottom: '24px', color: '#333', lineHeight: 1.6 }}>
          {translate('company.change.details.descriptionBefore')}{' '}
          <b>{translate('company.change.details.descriptionBold')}</b> {translate('company.change.details.descriptionAfter')}{' '}
          <span role="img" aria-label="pointing down">👇</span>
        </Typography>

        {documents.map((doc) => (
          <DocumentRow key={doc.label} {...doc} />
        ))}

        <Button
          fullWidth
          variant="outlined"
          onClick={handleAccept}
          style={{
            marginTop: '14px',
            borderRadius: '10px',
            padding: '14px',
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 600,
            borderColor: '#111',
            color: '#111',
          }}
        >
          {translate('company.change.details.continue')}
        </Button>

        {!hasComment && (
          <>
            <Divider style={{ margin: '16px 0 10px' }} />

            <Typography
              variant="body2"
              align="center"
              style={{ color: '#888', marginBottom: '12px' }}
            >
              {translate('company.change.limitante')}
            </Typography>

            <Button
              fullWidth
              variant="outlined"
              onClick={onLimitante}
              style={{
                borderRadius: '10px',
                padding: '14px',
                textTransform: 'none',
                fontSize: '16px',
                fontWeight: 500,
                borderColor: '#E5E7EB',
                color: '#111',
              }}
            >
              {translate('company.change.details.doubt')}
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ModalTermsDetails;
